import React, { useEffect, useState } from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'

export interface IMenuItem {
  id: string
  label: string
  url: string
  uri: string
}

const linkMap = [
  {
    test: 'o-nas',
    slug: 'o-nas',
  },
  {
    test: 'sluzby',
    slug: 'sluzby',
  },
  {
    test: 'sluzba',
    slug: 'sluzby',
  },
  {
    test: 'kariera',
    slug: 'kariera',
  },
  {
    test: 'volne-pozice',
    slug: 'kariera',
  },
  {
    test: 'blog',
    slug: 'blog',
  },
  {
    test: 'kontakt',
    slug: 'kontakt',
  },
]

export const Menu = () => {
  const [active, setActive] = useState<string>('')
  const { menu } = useStaticQuery(graphql`
    query MenuQuery {
      menu: allWpMenu(filter: { name: { eq: "Hlavní menu" } }) {
        nodes {
          name
          menuItems {
            nodes {
              id
              label
              url
              uri
            }
          }
          locations
        }
      }
    }
  `)

  const menuItems = menu.nodes[0].menuItems.nodes

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const { pathname } = location
      const root = pathname.split('/')[1] || ''

      const currentLink = linkMap.find((link) => link.test === root)

      if (currentLink) {
        setActive(currentLink.slug)
      }
    }
  }, [])

  return (
    <ul className="grid items-center content-center text-center md:flex gap-x-2 lg:gap-x-6 gap-y-8">
      {menuItems.map((item: IMenuItem) => {
        const isActive = item.uri.replace(/\//gi, '') === active

        return (
          <li key={item.id}>
            <Link
              className={`p-1 md:p-2 font-semibold text-lg text-primary-700 ${
                isActive ? 'border-b-2 border-secondary' : ''
              } hover:border-b-2 hover:border-secondary text-xl md:text-base transition-all`}
              to={item.uri}
            >
              {item.label}
            </Link>
          </li>
        )
      })}
    </ul>
  )
}
